import {
  ApprovalInstanceStatuses,
  PurchaseRequisitionStatuses,
  VersionStatuses,
} from "@tm-food/api-contract";
import { Badge } from "@/shared/ui/core/Badge";
import { resolveStatusTone } from "@/shared/ui/StatusBadge";
import { statusLabel } from "@/shared/ui/statusLabels";

export type WorkflowStatusBadgeProps = {
  status: string;
  /** Show raw status when unmapped (default: mapped label or raw). */
  fallbackLabel?: string;
};

/**
 * Entity workflow status — VI label from `statusLabel` + shared `resolveStatusTone`.
 * Approval instance `Pending` → remap via `instanceStatusToWorkflow` before render
 * (or toneKey remaps bare Pending → PendingApproval here).
 */
export function WorkflowStatusBadge({ status, fallbackLabel }: WorkflowStatusBadgeProps) {
  const label = fallbackLabel ?? statusLabel(status);
  /** Align bare `Pending` with approval wait (warning), not QC `pending` (info). */
  const toneKey =
    status === ApprovalInstanceStatuses.Pending
      ? VersionStatuses.PendingApproval
      : status;
  return (
    <Badge
      tone={resolveStatusTone(toneKey, label)}
      label={label}
      className="whitespace-nowrap"
    />
  );
}

/** Same SoT as StatusBadge — no parallel WORKFLOW_LABEL table. */
export function workflowStatusLabel(status: string): string {
  return statusLabel(status);
}

/**
 * Map approval **instance** status → entity workflow status key.
 * Instance `Pending` = chờ duyệt (not QC/op Pending).
 */
export function instanceStatusToWorkflow(status: string): string {
  if (status === ApprovalInstanceStatuses.Pending) {
    return VersionStatuses.PendingApproval;
  }
  return status;
}

export function isEntityAwaitingApproval(status: string): boolean {
  return (
    status === PurchaseRequisitionStatuses.Submitted ||
    status === VersionStatuses.PendingApproval
  );
}
